import {putAll, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {showBeError} from 'utils/show-be-error';

import {adminAction, GetManagementAssociationsOptionsAction} from '../action';

function* execute({payload}: GetManagementAssociationsOptionsAction): SagaIterator {
    const response = yield* call(Api.searchAssociationsForUser, {text: payload});

    if (response.isSuccess) {
        yield* put(adminAction.setManagementAssociationsOptions(response.data.map(o => ({
            value: o.id,
            label: o.name,
        }))));
    } else {
        yield putAll(showBeError(response, t('userDetail')('associationsLoading')));
    }
}
/** Runs the admin saga that loads association options for the management form. */
export function* getManagementAssociationsOptionsSaga(): SagaIterator {
    yield takeLatestF('admin/GET_MANAGEMENT_ASSOCIATIONS_OPTIONS', execute);
}
